import Typography from '@mui/material/Typography';

export type { Variant } from '@mui/material/styles/createTypography';
export type { TypographyProps, TypographyPropsVariantOverrides } from '@mui/material/Typography';

export default Typography;
